import {
  File,
  FileSpreadsheet,
  FileText,
  Image,
  type LucideIcon,
} from "lucide-react";
import { getFileIcon } from "../../lib/storage";

const iconMap: Record<string, LucideIcon> = {
  File,
  FileText,
  FileSpreadsheet,
  Image,
};

/**
 * The Lucide icon component representing an attachment's file type. Shared
 * between AttachmentList and AttachmentViewer so both render the same icon
 * for a given file.
 */
export function getAttachmentIcon(mimeType: string): LucideIcon {
  return iconMap[getFileIcon(mimeType)] || File;
}
